import { categoryDtoMap } from "../EmissionView/services/categoryDtoMap";
import { categoryRouteMap } from "../EmissionView/services/categoryRouteMap";

export const DATA_ENTRY_TEXT = {
  summary: ["Summary", "總表"],
  split: ["Split sheets", "分類表"],
  selectCategory: ["Select a single category before downloading.", "請先選擇單一類別後下載"],
  oldFile: ["This file uses an older format. Download a new Excel file, fill it in and upload it again.", "此檔案為舊版格式，請重新下載新版 Excel，填寫後再上傳。"],
  summaryLabel: ["Data Entry - Summary", "數據輸入－總表"],
  splitLabel: ["Data Entry - Split sheets", "數據輸入－分類表"],
  rows: ["Excel rows", "Excel 列"],
};

export const dataEntryText = (key, t, language) => {
  const [english, chinese] = DATA_ENTRY_TEXT[key];
  return t(english, {
    ns: "ActivityMain",
    defaultValue: /^(tw|zh[-_]tw|zh[-_]hant)$/i.test(language || "") ? chinese : english,
  });
};

export const getDataEntryImportLabel = (importType, t, language) => {
  if (importType === "dataEntrySummary") return dataEntryText("summaryLabel", t, language);
  if (importType === "dataEntrySplit") return dataEntryText("splitLabel", t, language);
  return "";
};

export const hasSingleDataEntryCategory = (selectedTab, standardId) => {
  const category = Number(standardId) === 2
    ? categoryDtoMap[selectedTab]
    : categoryRouteMap[selectedTab]?.replace(/^cat/, "");
  return Boolean(category && category.trim() && category !== "all");
};

export const isOldDataEntryFileError = (message) =>
  typeof message === "string" && message.includes("This file was downloaded from an older version of NxMAP.");
